/* Section registry — maps section keys to their components, in order. */
import { HeroSection } from './HeroSection.jsx'
import { PhilosophySection } from './PhilosophySection.jsx'
import { MethodSection } from './MethodSection.jsx'
import { DisciplinesSection } from './DisciplinesSection.jsx'
import { EngagementsSection } from './EngagementsSection.jsx'
import { DifferenceSection } from './DifferenceSection.jsx'
import { EnquirySection } from './EnquirySection.jsx'

export const SECTION_COMPONENTS = {
  hero: HeroSection,
  philosophy: PhilosophySection,
  method: MethodSection,
  disciplines: DisciplinesSection,
  engagements: EngagementsSection,
  difference: DifferenceSection,
  enquiry: EnquirySection,
}
